class BlogFilters extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.isMobile = window.matchMedia("(max-width: 989px)").matches;
    this.form = this.querySelector(".js-facets-form");
    this.apply = this.querySelector(".js-filter-apply");
    this.debouncedOnSubmit = debounce(event => this.onSubmitHandler(event), 500);

    this.isMobile ? this.initMobileFilters() : this.initDesktopFilters();
  }

  initMobileFilters() {
    const desktop = this.querySelector(".js-filters-desktop");

    this.apply.addEventListener("click", this.debouncedOnSubmit.bind(this));
    this.form.addEventListener('input', this.debouncedOnSubmit.bind(this));

    desktop.remove();
  }

  initDesktopFilters() {
    const drawer = this.querySelector(".js-filters-drawer");

    this.form.addEventListener('input', this.debouncedOnSubmit.bind(this));

    drawer.remove();
  }

  static setListeners() {
    const onHistoryChange = event => {
      const searchParams = event.state ? event.state.searchParams : BlogFilters.searchParamsInitial;

      if (searchParams === BlogFilters.searchParamsPrev) return;

      BlogFilters.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    BlogFilters.searchParamsPrev = searchParams;

    const sections = BlogFilters.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    document.getElementById('BlogGrid').classList.add('loading');

    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach(section => {
      const baseUrl = document.querySelector("blog-filters").dataset.url;
      const path =  `${baseUrl}${searchParams ? "/tagged/" + searchParams : ""}`;
      const url = `${path}?section_id=${section.section}`;
      const filterDataUrl = element => element.url === url;

      BlogFilters.filterData.some(filterDataUrl)
        ? BlogFilters.renderSectionFromCache(filterDataUrl, event)
        : BlogFilters.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) BlogFilters.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        BlogFilters.filterData = [...BlogFilters.filterData, { html, url }];
        BlogFilters.renderFunctions(html, event);

        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = BlogFilters.filterData.find(filterDataUrl).html;

    BlogFilters.renderFunctions(html, event);
  }

  static renderFunctions(html, event) {
    BlogFilters.renderFilters(html, event);
    BlogFilters.renderProductGridContainer(html);
    BlogFilters.renderProductCount(html);
    BlogFilters.renderDesktopDropdownActiveFacets(html);
    BlogFilters.renderDesktopFooterActiveFacetsBar(html);
    BlogFilters.renderPagination(html);
    BlogFilters.renderActiveFilterCount(html);
    BlogFilters.renderMobileDrawerHead(html);
    BlogFilters.renderMobileDrawerFooter(html);
  }

  static renderProductGridContainer(html) {
    const gridContainer = html.getElementById('BlogGrid');
    const newGridContainer = document.getElementById('BlogGrid');

    newGridContainer.innerHTML = gridContainer.innerHTML;
  }

  static renderActiveFilterCount(html) {
    const count = html.querySelector(".js-active-filters");
    const newCount = document.querySelector(".js-active-filters");

    if (count && newCount) newCount.innerHTML = count.innerHTML;
  }

  static renderProductCount(html) {
    const count = html.querySelector('.js-article-count').innerHTML;
    const container = document.querySelector('.js-article-count');

    container.innerHTML = count;
    container.classList.remove('loading');
  }

  static renderFilters(html, event) {
    const facetDetailsElements = html.querySelectorAll('#BlogFiltersForm .js-filter');
    const matchesIndex = element => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;

      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));

    facetsToRender.forEach(element => {
      const facet = element.querySelector(".filters__list");
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      const list = target.querySelector(".filters__list");

      if (list && facet) list.innerHTML = facet.innerHTML;
    });

    BlogFilters.renderActiveFacets(html);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [".js-refinements", ".js-refinements-mobile"];

    activeFacetElementSelectors.forEach(selector => {
      const activeFacetsElement = html.querySelector(selector);
      const newActiveFacetsElement = document.querySelector(selector)

      if (!activeFacetsElement || !newActiveFacetsElement) return;

      newActiveFacetsElement.innerHTML = activeFacetsElement.innerHTML;
    })

    BlogFilters.toggleActiveFacets(false);
  }

  static updateURLHash(searchParams) {
    const baseUrl = document.querySelector("blog-filters").dataset.url;
    const path =  `${baseUrl}${searchParams ? "/tagged/" + searchParams : ""}`;

    history.pushState({searchParams}, '', path);
  }

  static renderMobileDrawerHead(html) {
    const head = html.querySelector(".js-drawer-head");
    const newHead = document.querySelector(".js-drawer-head");

    if (head && newHead) newHead.innerHTML = head.innerHTML;
  }

  static renderMobileDrawerFooter(html) {
    const footer = html.querySelector(".js-product-count");
    const newFooter = document.querySelector(".js-product-count");

    if (footer && newFooter) newFooter.innerHTML = footer.innerHTML;
  }

  /* Desktop Dropdown Active Facets Information */
  static renderDesktopDropdownActiveFacets(html) {
    const facets = html.querySelectorAll(".js-filters-facets-head");
    const newFacets = document.querySelectorAll(".js-filters-facets-head");

    if (facets && newFacets)  newFacets.forEach((newFacet, index) => newFacet.innerHTML = facets[index].innerHTML)
  }

  /* Desktop Active Facets Plus Reset and Label */
  static renderDesktopFooterActiveFacetsBar(html) {
    const footer = html.querySelector(".js-filter-footer");
    const newFooter = document.querySelector(".js-filter-footer");

    if (footer && newFooter) newFooter.innerHTML = footer.innerHTML;
  }

  static renderPagination(html) {
    const pagination = html.querySelector('.js-pagination');
    const newPagination = document.querySelector('.js-pagination');

    if (pagination) newPagination.replaceWith(pagination);
  }

  static getSections() {
    return [{ section: document.getElementById('BlogMain').dataset.id }];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const formProps = Object.fromEntries(formData);

    return Object.values(formProps).toString();
  }

  onSubmitForm(searchParams, event) {
    BlogFilters.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const form = document.querySelector('blog-filters form');
    const noJsElements = document.querySelectorAll('.no-js-list');

    noJsElements.forEach(el => el.remove());

    this.onSubmitForm(this.createSearchParams(form), event);

    if (event.type === "click") publish(PUB_SUB_EVENTS.closeFilterDrawer);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    BlogFilters.toggleActiveFacets();

    const href = event.currentTarget.href;
    const url = href.indexOf('/tagged/') === -1 ? "" : href.slice(href.indexOf('/tagged/') + 8);

    BlogFilters.renderPage(url);
  }
}


BlogFilters.filterData = [];
BlogFilters.searchParamsInitial = window.location.search.slice(1);
BlogFilters.searchParamsPrev = window.location.search.slice(1);
BlogFilters.setListeners();

customElements.define("blog-filters", BlogFilters);

class BlogFacetRemove extends HTMLElement {
  constructor() {
    super();

    const facetLink = this.querySelector('a');

    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();

      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const form = this.closest('blog-filters');

    form.onActiveFilterClick(event);
  }
}

customElements.define('blog-facet-remove', BlogFacetRemove);
